const appraisalPort = {
  isIntegrated(customerNumber) {
    return `/integrations/appraisal-port/customers/${customerNumber}/is-integrated`;
  },
  status(controlIdNumber) {
    return `/integrations/appraisal-port/cases/${controlIdNumber}/status`;
  },
  holdReasons() {
    return `/integrations/appraisal-port/hold-reasons`;
  },
  onHold(controlIdNumber, reasonId) {
    return `/integrations/appraisal-port/cases/${controlIdNumber}/status/on-hold/${reasonId}`;
  },
  offHold(controlIdNumber) {
    return `/integrations/appraisal-port/cases/${controlIdNumber}/status/off-hold`;
  },
  message(controlIdNumber) {
    return `/integrations/appraisal-port/cases/${controlIdNumber}/message/`;
  },
};

export default appraisalPort;